export default "__VITE_ASSET__c993b775__"